import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	padding-top: 227px;
	background-color: #111314;
`;

const StyledCategories = styled.div`
	display: flex;
	gap: 20px;
	margin-top: 37px;
`;

const StyledCategory = styled.div<{ $active?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 18px;
	padding-top: 24px;
	width: 120px;
	height: 120px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 40px;
		height: 40px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${Text} {
			color: #000000;
		}
	}
`;

const StyledCloseButtonWrap = styled.div`
	position: absolute;
	bottom: 40px;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
`;

export {
	StyledCategories,
	StyledCategory,
	StyledCloseButtonWrap,
	StyledContainer,
};
